module.exports = __webpack_public_path__ + "2453a9a21ec68463f1ab21086a14df8f.svg";